import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import { GET_API_URLS } from "../../../../utils/constant";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { Loader, PropanePromotionCard } from "../../../../components/ui";
import { useAuth } from "../../../../context/AuthProvider";
import styles from "./style.module.scss";

const PropanePromotions = () => {
  const [loading, setLoading] = useState(true);
  const [promotionList, setPromotionList] = useState(null);
  const [error, setError] = useState(false);
  const { setAuth } = useAuth();
  // const navigate = useNavigate();

  useEffect(() => {
    // Getting Propane Promotions List
    jwtInterceoptor
      .get(GET_API_URLS.PROPANE_PROMOTIONS)
      .then((response) => {
        setLoading(false);
        setAuth((prev) => ({ ...prev, propanePromotions: response.data }));
        setPromotionList(response.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 403) {
          setError("You dont have permission to access this page.");
        } else {
          setError("There was a problem while loading the data.");
        }
        console.log("Error", error);
      });
  }, [setAuth]);

  // const handleEditPromotion = (promotion) => {
  //   navigate("/dashboard/add-propane-promotion", { state: promotion });
  // };

  if (loading) {
    return (
      <div className={styles.loadingPage}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.propanePromotionPage}>
      {error ? (
        <h3 style={{ textAlign: "center" }}>{error}</h3>
      ) : (
        <>


          <div className={styles.promotionBlock}>
            {promotionList && promotionList.length > 0 ? (
              promotionList.map((val, i) => (
                <PropanePromotionCard
                  id={val.id}
                  image={val.image}
                  name={val.name}
                  description={val.description}
                  effective_date={val.effective_date}
                  expiration_date={val.expiration_date}
                  link={val.link}
                  data={{ ...val }}
                  key={i}
                  onDelete={() => {
                    // Refresh the list after deletion
                    jwtInterceoptor
                      .get(GET_API_URLS.PROPANE_PROMOTIONS)
                      .then((response) => {
                        setPromotionList(response.data);
                        setAuth((prev) => ({ ...prev, propanePromotions: response.data }));
                      })
                      .catch((error) => {
                        console.log("Error refreshing list", error);
                      });
                  }}
                />
              ))
            ) : (
              <div className={styles.noPromotions}>
                <h2>No Propane Promotions</h2>
                <p>Click the "Add New Promotion" button to create your first promotion.</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PropanePromotions;
